import { render } from "./ChurchCommunication.vue?vue&type=template&id=38a6ff96"
import script from "./ChurchCommunication.vue?vue&type=script&lang=js"
export * from "./ChurchCommunication.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__